import { render } from './page';
import { $el, appShadowRoot } from './elements';
import { cookie } from './cookie';
import { noop } from './noop';

// Flips UI mode to 'authenticated' by modifying embedded views & nav state
export function mode(data = {}) {
  const lrecommended = (data.recommended || []).length > 0;

  render(async () => {
    $el.navbar.classList.add('authenticated');
    $el.footer.classList.add('authenticated');

    $el.profile.forEach((i) => i.classList.remove('is-hidden'));
    appShadowRoot.querySelectorAll('[data-id="preferences"]').forEach((arg) => arg.removeAttribute('disabled'));
    appShadowRoot.querySelectorAll('[data-id="signin"]').forEach((arg) => arg.classList.add('is-hidden'));
    $el.navbar.querySelector('.navbar-brand [data-id="signin"]').parentNode.classList.add('is-hidden');
    $el.navbar.querySelectorAll('[data-id="signout"]').forEach((arg) => arg.classList.remove('is-hidden'));
    $el.navbar.querySelectorAll('[data-id="apps"]').forEach((i) => i.classList.remove('is-hidden'));
    $el.navbar.querySelectorAll('[data-id="recommended-courses"]').forEach((i) => i.classList.remove('is-hidden'));
    appShadowRoot.querySelectorAll('.footer-login-link').forEach((i) => i.parentElement.classList.add('is-hidden'));

    $el.dashboard.forEach((i) => {
      i.classList.remove('is-hidden');
      i.removeAttribute('disabled');
      i.removeEventListener('click', noop);
    });

    appShadowRoot.querySelectorAll('[data-id="courses"]').forEach((i) => {
      i.classList.add('is-hidden');
      i.setAttribute('disabled', '');
    });

    appShadowRoot.querySelectorAll('#home [data-id="authToRecommended"]').forEach((i) => i.classList.add('is-hidden'));

    if (lrecommended === true || data.geo === true) {
      appShadowRoot.querySelectorAll('.authenticated.is-hidden').forEach((i) => i.classList.remove('is-hidden'));
    }
  });

  cookie('set', 'userGUID', data?.userId, 'adobe.com', true, false, 365);
}
